import type { FC, ReactElement, MouseEvent, MouseEventHandler } from 'react';
import React, { Children } from 'react';

import { scrollToHash } from '../helpers/scroll';

const onlyHashReg = /^#(.+)/;

const handleClick =
    (onClick: MouseEventHandler, options: { offset: number }, hash?: string) =>
    (event: MouseEvent) => {
        onClick(event);

        if (!hash) {
            return;
        }

        event.preventDefault();

        const anchorLabel = hash.slice(1);

        scrollToHash(anchorLabel, options);
    };

interface IScroller {
    children: ReactElement<{
        href?: string;
        onClick: MouseEventHandler;
    }>;
    offset?: number;
}

export const Scroller: FC<React.PropsWithChildren<IScroller>> = ({ children, offset = 0 }) => {
    const link = Children.only(children);

    let hash;
    const {
        props: { href, onClick },
    } = link;

    const targetHref = href || '';

    const match = targetHref.match(onlyHashReg);

    if (match) {
        [hash] = match;
    }

    const newProps = {
        ...link.props,
        onClick: handleClick(onClick, { offset }, hash),
    };

    return React.cloneElement(link, newProps);
};
